<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          v-if="permission('read', 'resident_hosting')"
          @click="handleStep('HOSPEDAGEM')"
          :class="[
            'nav-link link-nav-resident',
            step == 'HOSPEDAGEM' && 'active',
          ]"
          id="nav-hosting"
          data-toggle="tab"
          href="#hosting"
          role="tab"
          aria-controls="hosting"
          aria-selected="true"
          >HOSPEDAGEM</a
        >
        <a
          v-if="permission('read', 'resident_service')"
          @click="handleStep('SERVICO')"
          :class="['nav-link link-nav-resident', step == 'SERVICO' && 'active']"
          id="nav-service"
          data-toggle="tab"
          href="#service"
          role="tab"
          aria-controls="service"
          aria-selected="true"
          >SERVIÇO</a
        >
        <a
          v-if="permission('read', 'resident_rest_home_sale_resident')"
          @click="handleStep('VENDA')"
          :class="['nav-link link-nav-resident', step == 'VENDA' && 'active']"
          id="nav-sale"
          data-toggle="tab"
          href="#sale"
          role="tab"
          aria-controls="sale"
          aria-selected="true"
          >VENDA</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'HOSPEDAGEM'"
        :class="['tab-pane fade', step == 'HOSPEDAGEM' && 'show active']"
        id="hosting"
        role="tabpanel"
        aria-labelledby="nav-hosting"
      >
        <MenuHostingFinancial :resident="resident" />
      </div>
      <div
        v-if="step == 'SERVICO'"
        :class="['tab-pane fade', step == 'SERVICO' && 'show active']"
        id="service"
        role="tabpanel"
        aria-labelledby="nav-service"
      >
        <MenuService :resident="resident" />
      </div>
      <div
        v-if="step == 'VENDA'"
        :class="['tab-pane fade', step == 'VENDA' && 'show active']"
        id="sale"
        role="tabpanel"
        aria-labelledby="nav-sale"
      >
        <MenuSale :resident="resident" />
      </div>
    </div>
  </div>
</template>

<script>
import MenuHostingFinancial from "./MenuHostingFinancial";

import MenuService from "./MenuService";

import MenuSale from "./MenuSale";

import routes from "../../routes";

import permission from "../../lib/permission";

export default {
  name: "MenuFinancial",

  components: {
    MenuHostingFinancial,
    MenuService,
    MenuSale,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      step: "HOSPEDAGEM",

      resident_id: "",
    };
  },

  watch: {
    $route(to, from) {
      if (JSON.stringify(to.query) !== JSON.stringify(from.query)) {
        this.retrieve();
      }
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    handleStep(step) {
      let newNav;

      if (step == "HOSPEDAGEM") {
        newNav = "hosting";
      } else if (step == "SERVICO") {
        newNav = "service";
      } else if (step == "VENDA") {
        newNav = "sale";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },

    async retrieve() {
      const { nav } = routes.history.current.query;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      if (nav) {
        if (nav == "hosting") {
          this.step = "HOSPEDAGEM";
        } else if (nav == "service") {
          this.step = "SERVICO";
        } else if (nav == "sale") {
          this.step = "VENDA";
        } else {
          this.step = "HOSPEDAGEM";
        }
      }
    },
  },
};
</script>